<template>
  <div>
    <transition name="slide-fade">
      <component
        @exit="closeSecondDrawer()"
        :is="secondaryView"
        :secondaryDrawer="true"
        v-if="rightDrawer.opened && Boolean(secondaryView)"
      />
    </transition>
    <v-navigation-drawer
      v-if="rightDrawer.opened"
      v-model="rightDrawer.opened"
      :clipped="rightDrawer.clipped"
      fixed
      app
      right
      floating
      v-bind="
        rightDrawer.opened
          ? { permanent: true }
          : { disableResizeWatcher: true }
      "
      width="490"
      class="profile-wrap blue lighten-5 drawer-1"
    >
      <v-btn
        class="d-block d-md-none"
        title="Close"
        @click="exit()"
        text
        fab
        small
      >
        <v-icon dark>$close</v-icon>
      </v-btn>
      <div>
        <div class="d-flex align-center mb-8">
          <v-avatar size="70px">
            <v-img
              :src="getMedia(user)"
              :alt="user.name"
              lazy-src="/placeholder.jpg"
            />
          </v-avatar>
          <v-list-item color="primary">
            <v-list-item-content>
              <v-list-item-title
                class="title font-weight-bold letter-spacing-compact"
              >
                {{ user.full_name }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ user.email }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </div>
        <div class="d-flex justify-lg-space-between  mb-12 pb-8">
          <v-btn
            small
            color="white"
            class="elevation-0 font-weight-bold px-13 mr-6 body-2"
            height="40px"
            @click="changeProfile()"
          >
            Edit Profile
          </v-btn>
          <v-btn
            small
            color="white"
            class="elevation-0 font-weight-bold px-13 body-2"
            height="40px"
            @click="changeSettings()"
          >
            Settings
          </v-btn>
        </div>
        <div class="mb-12" v-if="user.isTourismOperator()">
          <div
            class="d-flex justify-space-between font-weight-bold mb-7  title"
          >
            <span class>Total Balance</span>
            <span>$ {{ user.getBalance() }}</span>
          </div>
          <div class="d-flex flex-column pb-12 mb-7">
            <v-btn
              :disabled="!user.hasBalance()"
              depressed
              medium
              color="amber accent-2 subtitle-1"
              class="elevation-0 font-weight-bold mb-4"
              height="50px"
              @click="makePayment()"
            >
              New Payout
            </v-btn>
            <v-btn
              style="display: none"
              depressed
              medium
              dark
              color="#383838"
              class="elevation-0 font-weight-bold black subtitle-1"
              height="50px"
            >
              Report
            </v-btn>
          </div>
        </div>
        <RecentTransactions v-if="user.isTourismOperator()" class="mb-5" />
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'AppRightBar',
  components: {
    Profile: () => import('@pages/users/Profile'),
    Settings: () => import('@pages/Settings'),
    Payout: () => import('@components/Payout'),
    RecentTransactions: () => import('@components/RecentTransactions'),
  },
  data() {
    return {
      secondaryView: '',
      openedFromDashboard: false,
    };
  },
  computed: {
    ...mapState('auth', {
      user: 'user',
    }),
  },
  methods: {
    changeProfile() {
      this.secondaryView = this.secondaryView === 'profile' ? '' : 'profile';
    },
    changeSettings() {
      this.secondaryView = this.secondaryView === 'settings' ? '' : 'settings';
    },
    makePayment() {
      this.secondaryView = this.secondaryView === 'payout' ? '' : 'payout';
    },
    exit() {
      this.rightDrawer.opened = false;
    },
    closeSecondDrawer() {
      this.secondaryView = '';
      if (this.openedFromDashboard) {
        this.openedFromDashboard = false;
        this.rightDrawer.opened = false;
      }
    },
  },
  beforeDestroy() {
    this.secondaryView = '';
  },
  mounted() {
    this.$bus.$on('MAKE_PAYMENT', async () => {
      this.rightDrawer.opened = true;
      this.openedFromDashboard = true;
      await this.$nextTick();
      this.makePayment();
    });
  },
};
</script>

<style lang="scss">
.profile-wrap {
  box-shadow: -1px 11px 15px gray;
}
</style>
